var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-modal",
        {
          attrs: { title: "Select Delivery Items", centered: "", size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.saveChanges },
                    },
                    [_vm._v("Save Changes")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.modalOpen,
            callback: function ($$v) {
              _vm.modalOpen = $$v
            },
            expression: "modalOpen",
          },
        },
        [
          _c(
            "div",
            { staticClass: "px-3 px-md-5" },
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end mb-2",
                  staticStyle: { position: "relative", "z-index": "1" },
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-danger", size: "sm" },
                      on: { click: _vm.clearFilters },
                    },
                    [_vm._v(" Clear Filters ")]
                  ),
                ],
                1
              ),
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "xl",
                  items: _vm.filteredDeliveryItems,
                  fields: _vm.deliveryItemFieldsModal,
                },
                scopedSlots: _vm._u([
                  {
                    key: "head(invoiceNo)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Invoice Number")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Search Invoice No",
                                size: "sm",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.invoiceNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "invoiceNo", $$v)
                                },
                                expression: "filters.invoiceNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(itemId)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Product Name")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Search Product Name",
                                size: "sm",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.itemId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "itemId", $$v)
                                },
                                expression: "filters.itemId",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(note)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Description")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Search Description",
                                size: "sm",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.note,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "note", $$v)
                                },
                                expression: "filters.note",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "head(quantity)",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Quantity")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Search Quantity",
                                size: "sm",
                                type: "number",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.currentPage = 1
                                },
                              },
                              model: {
                                value: _vm.filters.quantity,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "quantity", $$v)
                                },
                                expression: "filters.quantity",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(invoiceNo)",
                    fn: function (data) {
                      return [
                        _vm._v(" " + _vm._s(data.item.invoice.invoiceNo) + " "),
                      ]
                    },
                  },
                  {
                    key: "cell(itemId)",
                    fn: function (data) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " + _vm._s(_vm.getProductName(data.item.itemId))
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(description)",
                    fn: function (data) {
                      return [_vm._v(" " + _vm._s(data.item.description) + " ")]
                    },
                  },
                  {
                    key: "cell(quantity)",
                    fn: function (data) {
                      return [_vm._v(" " + _vm._s(data.item.quantity) + " ")]
                    },
                  },
                  {
                    key: "cell(check)",
                    fn: function (row) {
                      return [
                        _c("b-form-checkbox", {
                          model: {
                            value: row.item.selected,
                            callback: function ($$v) {
                              _vm.$set(row.item, "selected", $$v)
                            },
                            expression: "row.item.selected",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-card",
        { staticClass: "mt-3" },
        [
          _c("b-card-header", [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center",
              },
              [
                _c("div", { staticClass: "mr-5" }, [
                  _vm._v("Selected Delivery Item Details"),
                ]),
              ]
            ),
          ]),
          _c(
            "b-card-body",
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  items: _vm.selectedItemsWithStatus,
                  fields: _vm.selectedItemFields,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(productID)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getProductName(data.item.productID)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(note)",
                    fn: function (data) {
                      return [
                        _vm._v(" " + _vm._s(data.item.deliveryNote.note) + " "),
                      ]
                    },
                  },
                  {
                    key: "cell(quantity)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " + _vm._s(data.item.deliveryNote.quantity) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(status)",
                    fn: function (row) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant: _vm.getStatusColor(row.item.status),
                                },
                              },
                              [_vm._v(_vm._s(row.item.status))]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "m-1",
                            attrs: {
                              variant: "link",
                              "toggle-class": "p-0",
                              "no-caret": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c("feather-icon", {
                                        staticClass: "align-middle text-body",
                                        attrs: {
                                          icon: "MoreVerticalIcon",
                                          size: "16",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDeleteDelivery(data.item)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "TrashIcon" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "align-middle ml-1" },
                                  [_vm._v("Delete")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(check)",
                    fn: function (row) {
                      return [
                        _c("b-form-checkbox", {
                          model: {
                            value: row.item.selected,
                            callback: function ($$v) {
                              _vm.$set(row.item, "selected", $$v)
                            },
                            expression: "row.item.selected",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-md-1", attrs: { md: "6", cols: "6" } },
                    [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.SubmitDelivery($event)
                            },
                          },
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Vehicle",
                                "label-for": "vehicle",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "vehicleId",
                                  options: _vm.vehicleOptions,
                                  required: "",
                                },
                                model: {
                                  value: _vm.deliveryid.vehicleID,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.deliveryid, "vehicleID", $$v)
                                  },
                                  expression: "deliveryid.vehicleID",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: { label: "Driver", "label-for": "driver" },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "driverId",
                                  options: _vm.driverOptions,
                                  required: "",
                                },
                                model: {
                                  value: _vm.deliveryid.driverID,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.deliveryid, "driverID", $$v)
                                  },
                                  expression: "deliveryid.driverID",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Pickup Location",
                                "label-for": "pickUpLocation",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "pickUpLocation",
                                  options: _vm.locationOptions,
                                  required: "",
                                },
                                model: {
                                  value: _vm.deliveryid.pickUpLocation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.deliveryid,
                                      "pickUpLocation",
                                      $$v
                                    )
                                  },
                                  expression: "deliveryid.pickUpLocation",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Dropoff Location",
                                "label-for": "dropOffLocation",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "dropOffLocation",
                                  options: _vm.locationOptions,
                                  required: "",
                                },
                                model: {
                                  value: _vm.deliveryid.dropOffLocation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.deliveryid,
                                      "dropOffLocation",
                                      $$v
                                    )
                                  },
                                  expression: "deliveryid.dropOffLocation",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Delivery Date",
                                "label-for": "deliveryDate",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                attrs: {
                                  id: "deliveryDate",
                                  min: _vm.currentDate,
                                  required: "",
                                },
                                model: {
                                  value: _vm.deliveryid.deliveryDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.deliveryid,
                                      "deliveryDate",
                                      $$v
                                    )
                                  },
                                  expression: "deliveryid.deliveryDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Delivery Status",
                                "label-for": "deliveryStatus",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "deliveryStatus",
                                  options: _vm.deliveryStatusOptions,
                                  required: "",
                                },
                                model: {
                                  value: _vm.deliveryid.deliveryStatus,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.deliveryid,
                                      "deliveryStatus",
                                      $$v
                                    )
                                  },
                                  expression: "deliveryid.deliveryStatus",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            { attrs: { label: "Notes", "label-for": "notes" } },
                            [
                              _c("b-form-textarea", {
                                attrs: { id: "notes" },
                                model: {
                                  value: _vm.deliveryid.note,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.deliveryid, "note", $$v)
                                  },
                                  expression: "deliveryid.note",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("CustomFieldsDetails", {
                            attrs: {
                              AdditionalFields: _vm.deliveryid.additionalFields,
                              ModuleReference: "Delivery",
                            },
                            on: { onchange: _vm.additionalFieldChanges },
                          }),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button", block: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.SubmitDelivery()
                                },
                              },
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", {
                                    staticClass: "mx-2",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                              _vm._v("Save Changes "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "my-md-1", attrs: { md: "6", cols: "6" } },
                    [
                      _c(
                        "div",
                        { attrs: { align: "center" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(255, 255, 255, 0.15)",
                                  expression: "'rgba(255, 255, 255, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              attrs: {
                                variant: "primary",
                                target: "_blank",
                                href:
                                  "https://www.google.com/maps/dir/?api=1&origin=" +
                                  encodeURIComponent(
                                    _vm.deliveryid.pickUpLocation
                                  ) +
                                  "&destination=" +
                                  encodeURIComponent(
                                    _vm.deliveryid.dropOffLocation
                                  ),
                              },
                            },
                            [_vm._v("View Delivery Route")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }